
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './adminCertificate.css';

const AdminCourse = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState('');
  const [courses, setCourses] = useState([]);

  const fetchCourses = async () => {
    try {
      const res = await fetch(process.env.REACT_APP_API_URL+'/api/courses');
      const data = await res.json();
      setCourses(data.reverse());
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, [location.search]);

  const handleAddClick = () => {
    navigate('/admin/addcourse');
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this course?')) {
      try {
        await fetch(process.env.REACT_APP_API_URL+`/api/courses/${id}`, {
          method: 'DELETE',
        });
        fetchCourses();
      } catch (error) {
        console.error('Error deleting course:', error);
      }
    }
  };

  // ✅ Use "name" instead of "title"
  const filteredCourses = courses
    .filter(c =>
      (c?.name || '').toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if ((a?.name || '').toLowerCase().startsWith(searchTerm.toLowerCase())) {
        return -1;
      }
      return 0;
    });

  return (
    <div className="certificate-container">
      <header className="certificate-header">
        <img src="/flytutor_logo.png" alt="FlyTutor Logo" className="logo" />
        <h1 className="panel-title">Admin Panel</h1>
      </header>

      <div className="certificate-content">
        <div className="admin-name">
          <span className="label">Admin Name :</span>{' '}
          <span className="admin">Sanjay</span>
        </div>

        <div className="search-section">
          <input
            type="text"
            placeholder="Search..."
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button className="search-icon">🔍</button>
          <span className="certificate-tag">Courses</span>
        </div>

        <ul className="certification-list">
          {filteredCourses.map((item) => (
            <li key={item._id} className="certification-item">
              <span>{item?.name || 'Untitled Course'}</span>
              <div className="button-group">
                <button
                  className="update-btn"
                  onClick={() => navigate(`/admin/editcourse/${item._id}`)}
                >
                  🔁 update
                </button>
                <button
                  className="delete-btns"
                  onClick={() => handleDelete(item._id)}
                >
                  🗑️
                </button>
              </div>
            </li>
          ))}
        </ul>

        <button className="add-certification-btn" onClick={handleAddClick}>
          ➕
        </button>
      </div>
    </div>
  );
};

export default AdminCourse;
